import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldStandard} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldStandard;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorMessage = error?.message;

  return (
    <div className="w-full">
      <div className="flex gap-1 mb-2 items-center">
        <label className="tracking-wide font-bold">
          {blockable.label || '代表電話'}
        </label>
        {blockable.isRequired && <span className="text-red-500">*</span>}
      </div>
      <input
        className="form-input block w-full border rounded"
        type="tel"
        {...register(block.id)}
      />
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </div>
  );
};
